const FlexCol = ({
  children,
  tailwindGap = "gap-4",
  tailwindWidth = "w-full",
  className = "",
}) => {
  return (
    <div
      className={`flex flex-col items-center ${tailwindWidth} ${tailwindGap} ${className}`}
    >
      {children}
    </div>
  );
};

export default FlexCol;
